import {createContext} from 'react';
import {AuthProviderValue} from 'js/reusable/auth/types';

/* Typecasting the default context value because the context 
is currently only ever accessed in the AuthContext.Provider */
export const AuthContext = createContext<AuthProviderValue>({} as AuthProviderValue);
